<template>
  <div class="photo-capture">
    <img class="noah-logo" src="./icons/logo.svg">

    <div class="container">
      <router-link to="/" class="box">
        <div class="icon">
          <img class="icon" src="@/assets/icon/home.svg" :alt="$t('kasolcum.capture.home_alt')" />
        </div>
      </router-link>
  
      <router-link to="/portal" class="box">
        <div class="icon">
          <img class="icon" src="@/assets/icon/navigation/mobiluygulamalar.svg" :alt="$t('kasolcum.capture.portal_alt')" />
        </div>
      </router-link>  
  
      <div class="ai-logo">KAŞ <span style="font-weight: 400;">ÖLÇÜM</span></div>  
   
    </div> 
 

    <div class="button-container">
      <button @click="triggerInput(false)" :aria-label="$t('kasolcum.capture.gallery_alt')">
        <img class="btn-icon" src="./icons/gallery.svg" :alt="$t('kasolcum.capture.gallery_alt')">
      </button>
      <button @click="triggerInput(true)" :aria-label="$t('kasolcum.capture.camera_alt')">
        <img class="btn-icon" src="./icons/camera.svg" :alt="$t('kasolcum.capture.camera_alt')">
      </button>
    </div> 

    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      :capture="useCamera ? 'environment' : null"
      style="display: none;"
      @change="handleFileChange"
    />
  </div>
</template>

<script setup>
/* global defineEmits */
import { ref, nextTick } from 'vue'

const emit = defineEmits(['photo-captured'])

const fileInput = ref(null)
const useCamera = ref(false)
 
const triggerInput = (cameraMode) => {
  useCamera.value = cameraMode
  nextTick(() => {
    fileInput.value?.click()
  })
}
 
const handleFileChange = (event) => {
  const file = event.target.files[0]
  if (file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      emit('photo-captured', e.target.result)
    }
    reader.readAsDataURL(file)
  }
  event.target.value = ''
}
</script>


<style scoped>
.photo-capture {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; 
  gap: 5px;
  min-height: 40vh;
}

.button-container{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 1rem;
}
.photo-capture button {
  padding: 8px 16px;
  cursor: pointer;
  height: 5rem;
  width: 5rem;
  border: none;
  background: linear-gradient(45deg, #020202, #0a0a0a, #020202); 
  background: none;
  transition: transform 0.2s;
}

.photo-capture button:hover {
  transform: scale(1.05); 
  box-shadow: 0 5px 12px rgba(0, 104, 42, 0.2);
} 
.top-icon {
  max-width: 5rem;
} 
.noah-logo {
  max-width: 10rem;
  margin-bottom: 2rem;
}


.container {
  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center; 
  margin: 1em 0;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  min-width: 4em;
  min-height: 4em;
  border-radius: 8px;
  text-decoration: none;
  background-color: #050505;
  transition: transform 0.2s;
  color: #b5b5b5;
  font-size: 1.2em;
  font-weight: 300;
  cursor: pointer;
  border-bottom: 3px solid transparent;
}

.box:first-child {
  min-width: 5em;
} 
.box:hover {
  transform: scale(1.05);
  color: white;
  box-shadow: 0 5px 12px rgba(0, 104, 42, 0.2);
} 

.icon {
  min-width: 2em;
  max-height: 1.5em;
  opacity: 0.8;
}

.box:hover .icon {
  opacity: 1;
}

.ai-logo {
  font-size: 1.2em;
  font-weight: 200;
}

@media (max-width: 768px) {
  .container{
    justify-content: flex-start;
}
}
</style>
